/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

"use strict";

class OptionsApply {
	process(options, compiler) {}
}
module.exports = OptionsApply;
